import gql from 'graphql-tag';

/**
 * 获取热门搜索列表
 */
export const fetchHotWordsDocument = gql`
  query hotWords($options: HotWordListOptions) {
    hotWords(options: $options) {
      items {
        id
        name
        createdAt
        updatedAt
        type
        imgUrl
        jumpType
        jumpValue
      }
      totalItems
    }
  }
`;
